import script from "./InvoiceSection4.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection4.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection4.vue?vue&type=style&index=0&id=21ca108b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ca108b"]])

export default __exports__